export const exitMessage = [
    { heading: 'Aw! Don’t leave just yet.', content: 'Perhaps this note wasn’t the right fit for you, try reviewing a different note!' },
    { heading: 'Oh no! You are leaving?', content: 'Looks like you want to go back, how about trying a different note?' },
  ];